import { LoaderFunctionArgs, redirect } from "react-router-dom";

import { myAxios } from "src/components/common/functions";

export const approvalExtraFields = ["page", "limit"];

export async function approvalsLoader({ request }: LoaderFunctionArgs) {
    const url = new URL(request.url);
    let shouldRedirect = false;

    if (!url.searchParams.get("page")) {
        url.searchParams.set("page", "1");
        shouldRedirect = true;
    }
    if (!url.searchParams.get("limit")) {
        url.searchParams.set("limit", "10");
        shouldRedirect = true;
    }
    if (shouldRedirect) {
        throw redirect(url.pathname + "?" + url.searchParams.toString());
    }

    const formData = new FormData();
    formData.append("page", String(Number(url.searchParams.get("page"))));
    formData.append("limit", String(Number(url.searchParams.get("limit"))));

    const res = await myAxios({ fileName: "approvals/readApprovals.php", formData });
    if (!res) throw redirect("..");
    return res.data;
}
